import type { FaireProductEntity } from "../../entity_types/product";

export const p_b2zrr3vg2q: FaireProductEntity = {
  token: "p_b2zrr3vg2q",
  type: "product",
  name: "Women's Core Traverse Tek Tee",
  brandToken: "b_409pab9jko",
  brandName: "Unknown Brand",
  imageUrl:
    "https://cdn.faire.com/fastly/cf646a69d14ac3b5920c5326924e0843d10cd8e9c98aeb75607c8466111c79df.webp",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/5421fb92132b52c1a5c73d313adfed9be50aa6be09e1c7540c610f98a9a0d684.webp",
    "https://cdn.faire.com/fastly/04f4ba7016933fad535d1682c320a9080709bbc30bb9503c0f4ac486fa5a8be4.jpeg",
    "https://cdn.faire.com/fastly/6c975708e9fbf41cd7259457d549a590417d63397f9e84c98791f02a7de89978.webp",
    "https://cdn.faire.com/fastly/e0ab9585867055ca13cad8bf6f364612685af4f4299472c596ca0c63d9732fc3.webp",
    "https://cdn.faire.com/fastly/aee194407e6bcec38875d524ea5f257959703b973001ef5928682847b4472580.jpeg",
    "https://cdn.faire.com/fastly/ec711e6e340a21ccc74e15730dbf56c44d2c70cc6b720f645bfc89530b0ba45b.webp",
    "https://cdn.faire.com/fastly/19ee8346c62285f411fd1891c01d091d2b0d86ee438ea21c925faf26296635ea.jpeg",
    "https://cdn.faire.com/fastly/d6b0ee63ea442c8c7b003fc68c9992c66955fe548fca4a80773646ff621cea2b.webp",
    "https://cdn.faire.com/fastly/e544586c5f5e2fe234f2f83a35d6e3c906ba86548f852e7fb52fa5458b67fffa.webp",
    "https://cdn.faire.com/fastly/fea32d85c36e510226d3a6c5ee2c5de369459c195538f920c2fb3d479deb5add.jpeg",
    "https://cdn.faire.com/fastly/c2d82b5ef1a1f10de35e551dcb4bcb5afa8270c479af92a7b66b0ca8f1dc1659.webp",
    "https://cdn.faire.com/fastly/775bf5e8bfbe9b732a201d76d7d674a02ff90a860d321f29ca732f16d20ddca3.webp",
    "https://cdn.faire.com/fastly/50e92960389349f383ee0af35f7906e6e1ca04ecde4eff6669e7bd001b763e8b.webp",
    "https://cdn.faire.com/fastly/404d081086d76aa6d1c2c0e72d1e8e989289a2e93d9150b53f059c13627b78af.png",
    "https://cdn.faire.com/fastly/31827b225f839025887417d9a47fce929a8cc0be7ba314110e1a4b17d27d338c.jpeg",
    "https://cdn.faire.com/fastly/3820ddea1670b9c94bb3777569edb61421c4963c47062c1da5de74b56c2d52fb.jpeg",
    "https://cdn.faire.com/fastly/df22f7a812a696b730b6f7d1b5dc3bf9aa697af7588fc58552fe21faa99f6b44.jpeg",
    "https://cdn.faire.com/fastly/e4caec2d751b997281e4ce9ef9d1b7951b0c007230d2c8acb6d534d7b7e7584f.jpeg",
    "https://cdn.faire.com/fastly/7e676e3fb1b2bb4e43fa19089c3b95ac73dcdf20a126b08eb3f7c90fef72db99.jpeg",
    "https://cdn.faire.com/fastly/8a6cf4a9ba4f675d3a2196d963644ca4f0fae366b358b216c4db10a47849cb82.jpeg",
    "https://cdn.faire.com/fastly/2d89dc9da5ad5a12d77c3510dafc22b5c29345428727a6110ce04651b9474ffe.webp",
    "https://cdn.faire.com/fastly/f1f86e5bbcd42197769978692483634fbe88f17c6b284ea865c018f3a6aca508.webp",
    "https://cdn.faire.com/fastly/c03dd8487b0a9d7e5371c9b50defde107f2a4053a0793b9c05d2ff3b481f7333.png",
    "https://cdn.faire.com/fastly/11f9756a6581dc921b515ec1474d9281111497b1cabb1028592bfd3e575a4298.jpeg",
    "https://cdn.faire.com/fastly/2cd650ad9012cacc81e82991f8e3fab07badf7720a0d53acf9b0c96e7eee1ecd.jpeg",
    "https://cdn.faire.com/fastly/688efec3fa10f189417ab53951a82cddfe7550440aa8633fcbb1e57690a2dbb6.jpeg",
    "https://cdn.faire.com/fastly/44a14078039c174d21a67c78e66de7cf410bd66e7314c94c4abf8ea3033f07f6.jpeg",
    "https://cdn.faire.com/fastly/d67dcdbf470b4865206968ea0247f146c28d6274414dd5e1e4892ccf9350950d.jpeg",
    "https://cdn.faire.com/fastly/15c4ebd259ca83173a02f00ea89a676e870d9a41f33df334445739d09fdca1ec.jpeg",
    "https://cdn.faire.com/fastly/634944e3fd0ff83b23c88651dae7f795f7afe092ff55ff4c59a3889d2d6dfbdb.webp",
    "https://cdn.faire.com/fastly/2f72704b1859b1c4b33c4906038cc930f6823ed68f1dce0ceb24c9180587c749.webp",
    "https://cdn.faire.com/fastly/d6b6118b0c04f1b472917a65dd6e983ecbccddd9e5c493f517a9559d66e53040.webp",
  ],
  priceDollars: 30.49,
  description:
    "Produced with Recycled VersaTek™, our Core Traverse Tek Tees are dyed in colors that are meant to compliment every outfit. With an athletic fit and performance characteristics, our tees are comfortable throughout your active day.\n\n",
  tags: [],
  msrpDollars: 60.97,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T22:25:11.999Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
